import React from 'react'
import ControlButtonStandard, {ControlButtonType} from "../buttons/control-button/control-button-standard"
import UserStars from "../../manager/user/stars";
import ProjectSession from "../../model2/project/project-session";

type Props = {
    className?  : string

    project     : ProjectSession

    disabled?   : boolean
    callback?   : callback
}

// const debug = "Pin"
const debug = false

export default function StarProjectControl(props: Props) {

    if (props.disabled || gd.user.isCustomer()) return null

    const starProject = () => {
        userStars.addProject(props.project.id)
        props.callback?.()
    }

    const unstarProject = () => {
        userStars.removeProject(props.project.id)
        props.callback?.()
    }

    const userStars = new UserStars();
    const isStarred = userStars.isProjectStarred(props.project.id)


    if (!isStarred) {
        return (
            <ControlButtonStandard type          = {ControlButtonType.STAR}
                                   className    = {props.className}
                                   onClick      = {starProject}
                                   hint         = "Star"
                                   isDisabled    = {props.disabled}/>
        )
    }

    return (
        <ControlButtonStandard type         = {ControlButtonType.UNSTAR}
                               className    = {props.className}
                               onClick      = {unstarProject}
                               hint         = "Unstar"
                               isDisabled    = {props.disabled}/>
    )

}